require("!!D:\\Aliva\\IPCL\\IPCL_SELF_CARE\\node_modules\\script-loader\\addScript.js")(require("!!D:\\Aliva\\IPCL\\IPCL_SELF_CARE\\node_modules\\raw-loader\\index.js!D:\\Aliva\\IPCL\\IPCL_SELF_CARE\\node_modules\\chart.js\\dist\\Chart.bundle.min.js"))


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/script-loader!D:/Aliva/IPCL/IPCL_SELF_CARE/~/chart.js/dist/Chart.bundle.min.js
// module id = ../../../../script-loader/index.js!../../../../chart.js/dist/Chart.bundle.min.js
// module chunks = 3